<template>
  <div
    class="eu-display_flex eu-column eu-justify_center eu-gap_3 dash-progress-bar"
  >
    <div class="eu-display_flex eu-align-items_center eu-gap_2">
      <slot></slot>
      <emd-text data-testid="titleText">{{ title }}</emd-text>
    </div>
    <div class="eu-display_flex eu-align-items_center eu-gap_2">
      <emd-progress
        v-if="showBackground"
        :max="$attrs.max"
      >
        <emd-progress-bar
          v-bind="$attrs"
          @emitterProgress="setProgress"
        />
      </emd-progress>
      <emd-progress-bar
        v-else
        v-bind="$attrs"
        @emitterProgress="setProgress"
      />
      <span
        v-if="showCurrency"
        class="percentage_span"
        data-testid="show-currency"
        >{{ currency }}
      </span>
      <span
        v-else
        class="percentage_span"
        data-testid="show-progress"
        >{{ progress }}
      </span>
    </div>
  </div>
</template>

<script>
import {
  EmdProgressBar,
  EmdProgress,
  EmdText
} from 'emerald-vue/src/components'

export default {
  name: 'DashProgressBar',
  components: {
    EmdProgressBar,
    EmdProgress,
    EmdText
  },

  props: {
    title: String,
    showBackground: Boolean,
    showCurrency: Boolean,
    currency: String
  },

  data () {
    return {
      progress: ''
    }
  },

  methods: {
    setProgress (value) {
      this.progress = value
    }
  }
}
</script>

<style scoped>
.dash-progress-bar {
  margin-bottom: 16px;
}
.dash-progress-bar:last-child {
  margin-bottom: 0;
}
.dash-progress-bar .percentage_span {
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  white-space: nowrap;
}
</style>
